<template>
  <div class="mt-4 px-1">
    <div class="flex gap-x-2 bg-gray-100 rounded-[10px] p-3 mb-4">
      <i class="far fa-info-circle text-xs"></i>
      <p class=" text-sm cstu-text-gray-400">
        Enter your business website so AI can scan and learn your brand’s language, tone, and visual style to create tailored content.</p>
    </div>
    <div>
      <label class="block mb-2 font-medium text-[#3C4549]">
        Website URL
      </label>
      <TextInput
        :model-value="setupInfo.website.url"
        type="text"
        placeholder="e.g. www.yourbrand.com"
        full-width
        radius="lg"
        size="lg"
        @update:model-value="setupInfo.website.url = $event"
      />
    </div>
    <!-- <div class="mt-2">
      <h3 class="text-sm font-medium mb-2 py-2"
        >Examples of websites to create a great brand voice</h3
      >
      <div class="grid grid-cols-4 gap-6">
        <div
          v-for="site in exampleSites"
          :key="site.url"
          v-tooltip="'Open in new tab'"
          class="flex flex-col items-center gap-y-3 py-6 border rounded-xl cursor-pointer"
          :class="site.bg"
          @click="openUrl(site.url)"
        >
          <img :src="site.icon" :alt="site.name" class="w-8 h-8" />
          <a
            :href="site.url"
            target="_blank"
            class="text-sm font-medium text-[#3C4549]"
            >{{ site.name }}</a
          >
        </div>
      </div>
    </div> -->
  </div>
</template>

<script setup>
import { useSetup } from '@modules/publisher/ai-content-library/composables/useSetup'
import {TextInput} from '@contentstudio/ui'
import UserMavenLogo from '@assets/img/integration/usermaven_icon.svg'
import ContentPenLogo from '@assets/img/contentpen.svg'
import ReplugLogo from '@assets/img/integration/replug.svg'
import PostnitroLogo from '@assets/img/postnitro.svg'

 defineProps({
  mode: {
    type: String,
    default: 'setup',
  }
})

const { setupInfo } = useSetup()


const exampleSites = [
  {
    url: 'https://www.usermaven.com',
    name: 'UserMaven',
    icon: UserMavenLogo,
    bg: 'hover:bg-[#F5F6FF]',
  },
  {
    url: 'https://www.contentpen.ai',
    name: 'ContentPen',
    icon: ContentPenLogo,
    bg: 'hover:bg-[#FFF9EE]',
  },
  {
    url: 'https://www.replug.io',
    name: 'Replug',
    icon: ReplugLogo,
    bg: 'hover:bg-[#E5F7FF]',
  },
  {
    url: 'https://www.postnitro.ai',
    name: 'Postnitro',
    icon: PostnitroLogo,
    bg: 'hover:bg-[#EEF9F3]',
  },
]

const openUrl = (url) => {
  window.open(url, '_blank', 'noopener')
}
</script>
